import { DolfinParser } from './base'
import DolfinRecord from '../../record'
import { isNumber } from 'lodash'
import { toFormulaStringLiteral } from './utils/string-literal'

export class RecordParser extends DolfinParser {
  constructor(
    recordData: DolfinRecord,
    matcher?: RegExp,
    private inFormula: boolean = false
  ) {
    super(recordData, matcher)
  }

  execute(formula: string): string {
    const columns = this.recordData.getColumnNames()

    const parsedTags: (string | number | boolean | string[] | null)[] = []
    for (const columnTag of this.getTags(formula)) {
      if (this.matcher?.test(columnTag)) {
        parsedTags.push(
          this.parseColumn({
            columnTag,
            columns
          })
        )
      } else {
        parsedTags.push(columnTag)
      }
    }

    return parsedTags.join(' ')
  }

  private parseColumn({ columnTag, columns }: { columnTag: string; columns: string[] }) {
    if (!columns.includes(columnTag)) {
      throw new Error(`Column ${columnTag} not found in entity ${this.recordData.type}`)
    }

    let columnValue = this.recordData.getFieldValue(columnTag)

    if (
      this.inFormula &&
      (this.recordData.isDateColumn(columnTag) ||
        columnValue === 'true' ||
        columnValue === 'false' ||
        !isNumber(columnValue))
    ) {
      const columnValueAsText = columnValue ? String(columnValue) : ''
      columnValue = toFormulaStringLiteral(columnValueAsText)
    }

    return columnValue
  }
}
